var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"common-error_500"},[_c('div',{staticClass:"other-box"},[_c('img',{staticClass:"other-box-img",attrs:{"src":require("@/assets/images/other.png"),"alt":""}}),_c('div',{staticClass:"other-box-text"},[_vm._v(_vm._s(_vm.$t('common.noPage')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }